import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";
import { useTranslation } from "react-i18next";

import CalendyForm from "views/book-a-session/form.view";

export default function Features() {
  const { t } = useTranslation();

  return (
    <>
      <Head>
        <title>{t("common.bookASession")} - Submitapp</title>
        <meta
          name="description"
          content="Here you can book a new session to meet with us"
        />
      </Head>
      <main>
        <CalendyForm />
      </main>
    </>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}
